var exports = {
  "zr": "TasksView.module__root___TzVUVW",
  "KE": "TasksView.module__toolbar___TzVUVW",
  "vR": "TasksView.module__tabs___TzVUVW",
  "pb": "TasksView.module__filter___TzVUVW",
  "Mf": "TasksView.module__tab___TzVUVW",
  "T$": "TasksView.module__filterBtn___TzVUVW",
  "$V": "TasksView.module__tabOn___TzVUVW",
  "Kt": "TasksView.module__filterOn___TzVUVW",
  "z6": "TasksView.module__check___TzVUVW",
  "DD": "TasksView.module__title___TzVUVW",
  "TF": "TasksView.module__remove___TzVUVW",
  "Nr": "TasksView.module__card___TzVUVW",
  "uY": "TasksView.module__addRow___TzVUVW",
  "ZZ": "TasksView.module__field___TzVUVW",
  "si": "TasksView.module__fieldIcon___TzVUVW",
  "hF": "TasksView.module__input___TzVUVW",
  "aK": "TasksView.module__hint___TzVUVW",
  "p_": "TasksView.module__list___TzVUVW",
  "om": "TasksView.module__block___TzVUVW",
  "Oi": "TasksView.module__blockLabel___TzVUVW",
  "Os": "TasksView.module__group___TzVUVW",
  "uk": "TasksView.module__groupLate___TzVUVW",
  "NY": "TasksView.module__dueLate___TzVUVW",
  "nM": "TasksView.module__row___TzVUVW",
  "Tc": "TasksView.module__checkDone___TzVUVW",
  "tZ": "TasksView.module__rowDone___TzVUVW",
  "mI": "TasksView.module__meta___TzVUVW",
  "yA": "TasksView.module__avatarStack___TzVUVW",
  "zn": "TasksView.module__avatarStacked___TzVUVW",
  "fd": "TasksView.module__avatarMore___TzVUVW",
  "my": "TasksView.module__avatar___TzVUVW",
  "wJ": "TasksView.module__avatarSpacer___TzVUVW",
  "dQ": "TasksView.module__due___TzVUVW",
  "JT": "TasksView.module__dueInput___TzVUVW",
  "Gy": "TasksView.module__mark___TzVUVW",
  "Ie": "TasksView.module__empty___TzVUVW",
  "no": "TasksView.module__board___TzVUVW",
  "fi": "TasksView.module__column___TzVUVW",
  "vZ": "TasksView.module__columnOver___TzVUVW",
  "hi": "TasksView.module__columnHead___TzVUVW",
  "kR": "TasksView.module__cards___TzVUVW",
  "wy": "TasksView.module__cardDragging___TzVUVW",
  "Zv": "TasksView.module__cardDone___TzVUVW",
  "JJ": "TasksView.module__cardTitle___TzVUVW",
  "Nv": "TasksView.module__cardFoot___TzVUVW",
  "xF": "TasksView.module__cardRight___TzVUVW",
  "zE": "TasksView.module__cardArchive___TzVUVW",
  "Jj": "TasksView.module__columnRight___TzVUVW",
  "bX": "TasksView.module__columnAction___TzVUVW",
  "gG": "TasksView.module__columnAdd___TzVUVW",
  "cx": "TasksView.module__columnAddForm___TzVUVW",
  "QC": "TasksView.module__columnAddInput___TzVUVW",
  "RW": "TasksView.module__archivedRow___TzVUVW",
  "Xg": "TasksView.module__segmented___TzVUVW",
  "Z2": "TasksView.module__commentCount___TzVUVW",
};

module.exports = exports;
